<template>
	<div
		class="form-tags-parent text-left"
		:class="{ 'ft-invalidClass': error, 'ml-3': id != 'ml-unset' }"
	>
		<label class="mb-1">Tags<span v-show="isMandatory" class="asterik">*</span></label>
		<b-skeleton v-if="showLoader" height="38px"></b-skeleton>
		<template v-else>
			<b-form-tags
				:placeholder="placeholder"
				remove-on-delete
				v-model="modelValue[modelKey]"
				:tag-validator="validateTag"
				:disabled="disabled"
				:separator="' '"  
				@input="$emit('input')"
			></b-form-tags>
			<p class="ft-grey-txt pt-1 pl-1">Press enter to separate tags</p>
		</template>
	</div>
</template>

<script>
export default {
	name: "FormTags",
	props: {
		id: String,
		disabled: {
			type: Boolean,
			default: false,
		},
		showLoader: {
			type: Boolean,
			default: false,
		},
		modelValue: {
			type: Object,
			required: true,
		},
		placeholder: {
			type: String,
			default: "Enter",
		},
		modelKey: {
			type: String,
			required: true,
		},
		isMandatory: {
			type: Boolean,
			default: true,
		},
		error: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		validateTag(newTag) {
			const newTagLower = newTag.toLowerCase();
			const existingTags = this.modelValue[this.modelKey].map((tag) =>
				tag.toLowerCase()
			);
			return !existingTags.includes(newTagLower);
		},
	},
};
</script>

<style>
.form-tags-parent .b-form-tags-input {
	padding-bottom: 2px !important;
}
.form-tags-parent .form-control {
	border-radius: 0.5rem;
	background: var(--color-white);
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 0.5rem;
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-500);
	font-size: 16px;
	color: #565656;
}
.ft-invalidClass .form-control {
	border: 1px solid #eb0002 !important;
}

.form-tags-parent input::placeholder {
	color: var(--input-placeholder);
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-400);
	font-size: var(--size-14);
}

.ft-grey-txt {
	font-family: "Lato", sans-serif;
	font-size: var(--size-10);
	font-weight: var(--weight-500);
	color: var(--light-grey);
}

.form-tags-parent .b-form-tag {
	background-color: var(--primary-blue);
	border-radius: 1.25rem;
	padding-left: 0.125rem 0.625rem;
}

.form-tags-parent .b-form-tag > button.b-form-tag-remove {
	font-size: 101%;
	line-height: 1;
	padding: 0 0.125rem;
	float: none;
	top: 1px;
	margin-left: 0.25rem;
	color: var(--primary-blue);
	border: 1px solid var(--primary-blue);
	border-radius: 0.813rem;
	height: 0.813rem;
	/* width: 12px; */
	position: relative;
	opacity: 1;
}
.add-res-tabs .form-tags-parent ul {
	width: 100%;
}

.form-tags-parent .badge-secondary {
	background-color: #f1f7ff;
	border-radius: 0.9375rem;
	padding: 0.125rem 0.375rem;
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-R);
	font-size: var(--size-12);
	color: var(--primary-blue);
}

.form-tags-parent .btn-outline-secondary {
	color: var(--primary-blue);
	border-color: var(--primary-blue);
	border-radius: 20px;
}

.form-tags-parent .btn-outline-secondary:hover {
	background-color: var(--primary-blue);
	color: #ffffff;
}
.form-control:focus {
	box-shadow: none !important;
}
.b-form-tags.focus {
	box-shadow: none !important;
}
.b-form-tags.disabled {
	background-color: #f5f5f5 !important;
}
.b-form-tags.disabled .btn {
	visibility: hidden;
}
</style>
